import { RootState } from "store/store";
import Tenants from "./Tenants";
import { connect } from "react-redux";
import { fetchEnvironments } from "store/environments/environment-thunks";
import { fetchTenants } from "store/environments/tenants/tenants-thunks";
import {
    setActiveTenant,
    updateTenantVersionInfo,
} from "store/environments/tenants/tenants-actions";
import { getFilteredTenantsSortedByNameAndStatus } from "store/environments/tenants/tenants-selectors";
import {
    getActiveEnvironmentId,
    getActiveEnvironmentMoniker,
    getActiveEnvironmentTenantIds,
} from "store/environments/environment-selectors";
import { pingTenantInD365 } from "store/environments/tenants/tenant-ping/tenant-ping-thunk";
import { getTenantsPingInfoSelector } from "store/environments/tenants/tenant-ping/tenant-ping-selectors";
import { getAppSettings } from "store/app-settings/app-settings-selectors";
import {
    setErrorMessageInactiveTenant,
    setErrorResponseMessage,
} from "store/common/initialization/initialization-actions";
import { setLoaderVisibility } from "store/common/initialization/initialization-actions";
import { getIsUserPartner } from "store/app-global/app-global-selectors";
import {
    setTenantMoniker,
    setTenantStatusInfo,
    setTenantStatusOpened,
} from "store/environments/tenants/tenant-status/tenant-status-actions";
import { getIsLoaderVisible } from "store/common/initialization/initialization-selectors";

const mapStateToProps = (state: RootState) => {
    const envMoniker = getActiveEnvironmentMoniker(state);

    return {
        appSettings: getAppSettings(state),
        tenantsPingInfo: getTenantsPingInfoSelector(state, envMoniker),
        activeEnvironmentId: getActiveEnvironmentId(state),
        activeEnvMoniker: envMoniker,
        activeEnvironmentTenantIds: getActiveEnvironmentTenantIds(state),
        modifiedTenants: getFilteredTenantsSortedByNameAndStatus(state),
        errorMessage:
            state.initializationReducer.errorResponseMessage ||
            state.initializationReducer.errorMessageInactiveEnvironment,
        isLoaderVisible: getIsLoaderVisible(state),
        isUserPartner: getIsUserPartner(state),
    };
};
const TenantsContainer = connect(mapStateToProps, {
    fetchEnvironments,
    fetchTenants,
    setActiveTenant,
    pingTenantInD365,
    setErrorResponseMessage,
    setLoaderVisibility,
    setTenantStatusOpened,
    setTenantStatusInfo,
    setTenantMoniker,
    setErrorMessageInactiveTenant,
    updateTenantVersionInfo,
})(Tenants);

export default TenantsContainer;
